import React from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import {
  empty,
  emptyEditor,
  required,
} from '../../../../../antd/form/FormValidation.js';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import FormTextEditor from '../../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import { Col, Form as AntdForm, Row } from 'antd';
import FormDate from '../../../../../antd/form/FormDate/FormDate.jsx';
import dayjs from 'dayjs';
import { DATETIME_FORMAT_DATE } from '../../../../../../utils/helpers/CommonHelper.jsx';
import FormItem from 'antd/lib/form/FormItem';

const EventsForm = ({ onSubmit, initials, form }) => {
  const { t } = useTranslation();
  const { getFieldValue } = form;

  initials.date_from = initials.date_from
    ? dayjs(initials.date_from)
    : undefined;
  initials.date_to = initials.date_to ? dayjs(initials.date_to) : undefined;

  const handleSubmit = (values) => {
    const cleanedValues = {
      ...values,
      date_from: values.date_from
        ? values.date_from.format('YYYY-MM-DD')
        : null,
      date_to: values.date_to ? values.date_to.format('YYYY-MM-DD') : null,
    };
    onSubmit(cleanedValues);
  };

  const watchFrom = AntdForm.useWatch('date_from', form);

  const disabledDate = (current) => {
    return current.isBefore(dayjs(), 'day');
  };
  const disabledDateTo = (current) => {
    if (!watchFrom) {
      return current.isBefore(dayjs(), 'day');
    }
    return watchFrom.isAfter(current, 'day');
  };

  return (
    <Form form={form} onFinish={handleSubmit} initialValues={initials}>
      <FormTextField label={t('Názov')} name={'name'} rules={[empty(t)]} />
      <FormItem label={t('Realizácia')}>
        <Row gutter={[10]}>
          <Col span={5}>
            <FormDate
              name="date_from"
              label={t('Od')}
              defaultValue={initials.date_from}
              rules={[required(t)]}
              style={{ width: '100%' }}
              disabledDate={disabledDate}
            />
          </Col>
          <Col span={5}>
            <FormDate
              name="date_to"
              label={t('Do')}
              defaultValue={initials.date_to}
              dependencies={['date_from']}
              rules={[
                {
                  validator: async (_, date_to) => {
                    const date_from = getFieldValue('date_from');
                    if (!date_from) {
                      return Promise.resolve();
                    }
                    if (!date_to) {
                      return Promise.resolve();
                    }
                    if (dayjs(date_to).isBefore(dayjs(date_from), 'day')) {
                      return Promise.reject(
                        new Error(t('Koniec musí byť neskôr ako začiatok')),
                      );
                    }
                    return Promise.resolve();
                  },
                },
                required(t),
              ]}
              disabledDate={disabledDateTo}
              style={{ width: '100%' }}
              format={DATETIME_FORMAT_DATE}
            />
          </Col>
        </Row>
      </FormItem>
      <FormTextEditor
        label={t('Popis')}
        name={'description'}
        rules={[emptyEditor(t)]}
      />
      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'events'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default EventsForm;
